import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
// import { firebase_app } from '../data/config';
import { authHeader, handleResponse } from '../services/fack.backend';

const PrivateRoute = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const [authenticated, setAuthenticated] = useState(false)
    const jwt_token = localStorage.getItem('access');
    const location = useLocation();

    useEffect(() => {
        const abortController = new AbortController();
        const requestOptions = { method: 'GET', headers: authHeader() };
        fetch('/users', requestOptions).then(handleResponse)
        // firebase_app.auth().onAuthStateChanged(setCurrentUser);
        setAuthenticated(JSON.parse(localStorage.getItem("authenticated")))

        // console.log("********************************calling********************************");
        // console.log("currentUser", currentUser !== null);
        // console.log("authenticated", authenticated);
        // console.log("jwt_token", jwt_token);

        return function cleanup() {
            abortController.abort();
        }
    }, []);

    const isLogged = currentUser !== null || authenticated || jwt_token;

    if (!isLogged) {
        if (location.pathname !== '/' && !location.pathname.includes('/signin') && !location.pathname.includes('/login')) {
            localStorage.setItem('redirectUrl', location.pathname + location.search);
        }
        return <Navigate to={`${process.env.PUBLIC_URL}/signin`} />;
    }

    return <Outlet />;
}

export default PrivateRoute;

